import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element";
import FieldMultiselect_FormComponent from "../components/form/form-component";

export default class FieldMultiselect_FormElement extends FieldProto_FormElement {

    render() {

        return <FieldMultiselect_FormComponent
                                               field                = {this.props.field}
                                               // viewClasses          = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", this.props.className)}
                                               className              = {this.props.className}
                                               value                = {this.value}
                                               disabled             = {this.props.disabled}
                                               onChange             = {this.onChange}
                                               onImmediateChange    = {this.onChange}/>
    }

}
